export const STORAGE_KEYS = {
  token: "TOKEN",
  credentials: "CREDENTIALS",
};
